import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

function NtModalTitle({ style, ...otherProps }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return <NtText style={[styles.text, style]} {...otherProps} />;
}

const makeStyles = (t) =>
  StyleSheet.create({
    text: {
      color: t.text,
      fontSize: 16,
      fontWeight: "700",
      letterSpacing: -0.2,
    },
  });

export default NtModalTitle;
